
export const DISPLAY_TIME_ZONE = 'Australia/Brisbane';
export const DISPLAY_TIME_ZONE_LABEL = 'GBRT';

const displayDateFormatter = new Intl.DateTimeFormat('en-AU', {
  timeZone: DISPLAY_TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const displayDateTimeFormatter = new Intl.DateTimeFormat('en-AU', {
  timeZone: DISPLAY_TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: true,
});

function toDate(value: any) {
  return value instanceof Date ? value : new Date(value);
}

export function formatDisplayDate(value: any) {
  return displayDateFormatter.format(toDate(value));
}

export function formatDisplayDateTime(value: any) {
  return `${displayDateTimeFormatter.format(toDate(value))} ${DISPLAY_TIME_ZONE_LABEL}`;
}

export function getDaysSince(entry: any) {
  if (!entry?.date) {
    return 0;
  }

  const diff = Math.abs(new Date().getTime() - new Date(entry.date).getTime());
  return Math.ceil(diff / (1000 * 3600 * 24)); 
}

export function getDaysBetween(earliest: any, latest: any) {
  const diff = Math.abs(new Date(earliest.date).getTime() - new Date(latest.date).getTime());
  return Math.ceil(diff / (1000 * 3600 * 24)); 
}

export function getLatestPing(entries: any) {
  const now = new Date().getTime();

  const latest = entries.reduce((previous: number, entry: any) => {
    const diff = Math.abs(now - new Date(entry.date).getTime());
    return diff < previous ? diff : previous;
  }, Infinity)
  return Math.ceil(latest / (1000 * 3600 * 24)); 
}